/**
 * IGIN Global JS
 * - IntersectionObserver scroll reveals (.igin-reveal)
 * - Global parallax doodle background (#iginDoodleBg)
 * - Strolling apple companion (#iginStrollDoodle)
 * Loaded deferred in theme.liquid
 */
(function () {
  'use strict';

  // =============================================
  // SCROLL REVEAL
  // =============================================
  var revealObs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
  );
  document.querySelectorAll('.igin-reveal').forEach(function (el) {
    revealObs.observe(el);
  });

  // =============================================
  // GLOBAL PARALLAX DOODLE BACKGROUND
  // =============================================
  var bgEl = document.getElementById('iginDoodleBg');
  if (bgEl) {
    var doodleAssets = window.iginDoodleAssets || [];
    var bgItems = [];

    if (doodleAssets.length > 0) {
      for (var i = 0; i < 40; i++) {
        var img = document.createElement('img');
        img.src = doodleAssets[i % doodleAssets.length];
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('loading', 'lazy');
        var s = 30 + Math.random() * 60;
        var x = Math.random() * 100;
        var y = (i / 40) * 100 + Math.random() * 2.5;
        var speed = 0.02 + Math.random() * 0.04;
        var rot = Math.random() * 20 - 10;
        img.style.cssText =
          'width:' + s + 'px;height:' + s + 'px;object-fit:contain;' +
          'left:' + x + '%;top:' + y + '%;transform:rotate(' + rot + 'deg);position:absolute;';
        bgEl.appendChild(img);
        bgItems.push({ el: img, speed: speed, baseRot: rot });
      }

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            requestAnimationFrame(function () {
              var scrollY = window.scrollY;
              bgItems.forEach(function (item) {
                var offset = scrollY * item.speed;
                item.el.style.transform =
                  'translateY(' + -offset + 'px) rotate(' + (item.baseRot + offset * 0.02) + 'deg)';
              });
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );
    }
  }

  // =============================================
  // STROLLING APPLE COMPANION
  // =============================================
  var strollEl = document.getElementById('iginStrollDoodle');
  if (strollEl) {
    var editorials = document.querySelectorAll('.igin-editorial-wrapper');

    function updateStroll() {
      if (editorials.length < 1) return;
      var firstRect = editorials[0].getBoundingClientRect();
      var lastRect = editorials[editorials.length - 1].getBoundingClientRect();
      var vpH = window.innerHeight;
      var zoneBottom = lastRect.bottom;
      var zoneH = zoneBottom - firstRect.top;
      var progress = 1 - zoneBottom / (vpH + zoneH);

      if (progress < 0 || progress > 1) {
        strollEl.classList.remove('active');
        return;
      }

      strollEl.classList.add('active');
      var x = window.innerWidth * 0.85;
      var y = vpH * (0.1 + progress * 0.7);
      strollEl.style.left = '0';
      strollEl.style.top = '0';
      strollEl.style.transform = 'translate(' + (x - 30) + 'px,' + (y - 30) + 'px)';
    }

    window.addEventListener('scroll', function () {
      requestAnimationFrame(updateStroll);
    }, { passive: true });

    setTimeout(updateStroll, 600);
  }

})();

/* ============================================================
   IGIN PAPER FLOW globals
   - .rv reveal system, one IntersectionObserver
   - hero sound toggle ([data-igin-sound])
   Both re-run on shopify:section:load, because the theme editor
   re-renders a section without re-running its script.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
  }

  function bindReveals(scope) {
    var targets = (scope || document).querySelectorAll('.rv:not(.is-in)');
    /* In the theme editor a re-rendered section can strand a reveal
       mid-fade, so there everything gets its final state at once. */
    var instant = !io || (window.Shopify && window.Shopify.designMode);
    Array.prototype.forEach.call(targets, function (el) {
      if (instant) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  function bindSound(scope) {
    var btns = (scope || document).querySelectorAll('[data-igin-sound]');
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.getAttribute('data-igin-sound-ready') === 'true') return;
      btn.setAttribute('data-igin-sound-ready', 'true');
      btn.addEventListener('click', function () {
        var video = document.querySelector(btn.getAttribute('data-igin-sound'));
        if (!video) return;
        video.muted = !video.muted;
        btn.textContent = video.muted
          ? btn.getAttribute('data-label-off')
          : btn.getAttribute('data-label-on');
        if (!video.muted) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    });
  }

  function boot(scope) {
    bindReveals(scope);
    bindSound(scope);
  }

  boot(document);
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();
